import {Component, EventEmitter, Input, Output} from "@angular/core";
import {selector} from "d3";

@Component({
    selector: 'data-table-pager',
    templateUrl: 'data-table-pager.component.html',
    styleUrls: ['data-table-pager.component.less']
})
export class DataTablePagerComponent {
    
    private _pageIndex: number = 0;
    
    @Input('PageIndex')
    public set PageIndex(value: number) {
        if (value == null || value == this._pageIndex) {
            return;
        }
        this._pageIndex = value;
        this.PageIndexChange.emit(value);
    }
    
    public get PageIndex() {
        return this._pageIndex;
    }
    
    public set PageNum(value: number) {
        this.PageIndex = Math.min(Math.max(value - 1, 0), this.PageCount - 1);
    }
    
    public get PageNum() {
        return this._pageIndex + 1;
    }
    
    @Output('PageIndexChange')
    public PageIndexChange = new EventEmitter<number>(true);

    @Input('PageCount')
    public PageCount: number;
    
    constructor() {}
    
    public GetPageCountDisplay() {
        return this.PageCount && !isNaN(this.PageCount) ? this.PageCount : '';
    }
    
    public GoToFirst() {
        this.PageIndex = 0;
    }
    
    public GoToPrevious() {
        this.PageIndex = Math.max(this.PageIndex - 1, 0);
    }
    
    public GoToNext() {
        this.PageIndex = Math.min(this.PageIndex + 1, this.PageCount - 1);
    }
    
    public GoToLast() {
        this.PageIndex = this.PageCount - 1;
    }
}